import { IEvent } from '~/Models/DTO/Event.model';
import { IOrderline, OrderlineType } from '../Models/DTO/Orderline.models';
import { EventGroup } from '~/Models/DTO/EventGroup.model';

export const isEmpty = (obj: any) => {
  if (obj === null || obj === undefined) {
    return true;
  }
  return Object.keys(obj).length === 0 && obj.constructor === Object;
};

export const readFileFromDataUrl = (dataUrl: Blob) =>
  new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = reject;
    reader.onload = () => resolve(reader.result as string);
    reader.readAsDataURL(dataUrl);
  });

export const getFirstUsableProduct = (orderlines: IOrderline[]) => {
  let usableOrderline = orderlines.find((orderline) => orderline.type === OrderlineType.CONTRACT);

  if (!usableOrderline) {
    usableOrderline = orderlines.find((orderline) => orderline.type === OrderlineType.CREDITPASS);
  }

  if (!usableOrderline) {
    usableOrderline = orderlines.find((orderline) => orderline.type === OrderlineType.SINGLEEVENT);
  }

  return usableOrderline || orderlines[0];
};

export const isIntegratedEvent = (event: IEvent | EventGroup) =>
  !!event?.source && event.source.toLocaleLowerCase() !== 'fitogram';
